import { tw } from 'utils/classnames'

type LabelVariant = 'SmallBadge' | 'LargeBadge' | 'ColorBadge' | 'IconBadge'

interface LabelProps {
  className?: string
  variant?: LabelVariant
  children: React.ReactNode
}

export function Label({ className, children, variant = 'LargeBadge' }: LabelProps) {
  return (
    <div
      className={tw(
        'rounded text-center text-gray-50 flex items-center gap-0.5 text-ellipsis max-w-full',
        variant === 'SmallBadge' &&
          'backdrop-blur-sm bg-gray-700-opacity px-1 py-0.5 typography-10-capitals',
        variant === 'IconBadge' &&
          'backdrop-blur-sm bg-studio-gray-800/30 text-studio-gray-0 px-1 py-px typography-10',
        variant === 'ColorBadge' &&
          'bg-orange-500 text-service-white-white px-[5px] py-1 typography-10-capitals',
        variant === 'LargeBadge' &&
          'backdrop-blur-sm bg-service-black-black/50 text-service-white-white px-2 py-1 typography-12',
        className,
      )}
    >
      {children}
    </div>
  )
}
